import { DefaultService } from '@/services/DefaultService';

export default class AssFunilUsuarioService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, id, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/funil/assfunilusuario.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idfunil=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacao(assFunilUsuario) {
        return this._http.post(`${this._env}/ven/funil/assfunilusuario/updatesituacao`, assFunilUsuario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociados(column, order, page, limit, id, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/funil/assfunilusuario/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idfunil=${id}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(lista) {
        return this._http.post(`${this._env}/ven/funil/assfunilusuario`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}